/**
 * This custom label is a workaround by directly rotating the text that is used to act as a label to the y axis
 * TODO: Eventually replace this with ReCharts angle property when bug fix is implemented
 * @param height
 * @param value
 */
export default function RotatedYAxisLabel({
  height,
  value,
  bold = false,
}: {
  height: number;
  value: number | string;
  bold?: boolean;
}) {
  return (
    <g>
      <text
        textAnchor="middle"
        fontWeight={bold ? "bold" : "normal"}
        transform={`rotate(-90,15,0) translate(-${height / 2},0)`}
      >
        {value}
      </text>
    </g>
  );
}
